import { MyAxios, handleResponse, handleError } from '@services/SettingAxios';

export type ResponseData = {
  id: number;
  xCoord: number;
  yCoord: number;
  zoom: number;
  comment: string;
  yandexMapId: string;
  yandexMapUrl: string;
  googleMapUrl: string;
  gisMapUrl: string;
  iconUrl: any;
  eyeColor: any;
  color: any;
  outerStrokeColor: any;
  yandexRating: string;
  yandexRatingCount: string;
  yandexRatingReviews: string;
  priority: string;
};

export const getInfoMapDataByShopId = async (shopId: number): Promise<ResponseData> => {
  return await MyAxios.get(`/api/shops/get-map-info?shopId=${shopId}`).then(handleResponse).catch(handleError);
};
